angular.module('impactx.attributes').directive('ixAttributeSelection', function ()
{
    return {
        scope: {
            attributeData: "=",
            patListEntryPoint: "@",
            inputForPatEntryPoint: "@",
            readOnly: "="
        },
        restrict: 'E',
        controller: 'AttributeSelectionCtrl',
        controllerAs: 'attributeSelectionCtrl',
        templateUrl: 'shared/attributes/templates/attributeselection.tmpl.html',
        transclude: true
    };
});